import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth, USER_TYPE_ROUTES } from '../context/AuthContext';
import { changePassword } from '../api';
import '../styles/login.css';

const LockIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

const AlertIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
);

const ArtemisLogo = () => (
  <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 4L4 28h28L18 4z" fill="white" fillOpacity={0.9} />
    <path d="M18 12l-6 12h12l-6-12z" fill="white" fillOpacity={0.5} />
  </svg>
);

const RULE = 'Mínimo 8 caracteres, con una mayúscula, un número y un carácter especial.';

export default function ForcePasswordChangeView() {
  useEffect(() => { document.title = 'Artemis — Nueva contraseña'; }, []);

  const { user, login, logout } = useAuth();
  const navigate = useNavigate();

  const [pwd, setPwd] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (pwd !== confirm) {
      setError('Las contraseñas no coinciden.');
      return;
    }

    setLoading(true);
    try {
      const data = await changePassword(pwd);
      login(data.access_token, data.user); // limpia must_change_password
      navigate(USER_TYPE_ROUTES[data.user.user_type] ?? '/', { replace: true });
    } catch (err) {
      setError(err.message || 'No se pudo cambiar la contraseña.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card" key="force-pwd">
        <div className="login-brand">
          <div className="login-brand-logo">
            <ArtemisLogo />
          </div>
          <h1 className="login-brand-title">Artemis</h1>
          <p className="login-brand-subtitle">Sistema de Gestión Educativa</p>
        </div>

        <h2 className="login-heading">Crea tu contraseña</h2>
        <p className="login-choose-hint">
          {user?.full_name ? `${user.full_name.split(' ')[0]}, ` : ''}
          tu contraseña actual fue generada por un administrador. Define una
          contraseña personal para continuar.
        </p>

        <form className="login-form" onSubmit={handleSubmit} noValidate>
          {error && (
            <div className="login-error" role="alert">
              <AlertIcon />
              <span>{error}</span>
            </div>
          )}

          <div className="login-field">
            <label className="login-label" htmlFor="fp-new">Nueva contraseña</label>
            <div className="login-input-wrapper">
              <span className="login-input-icon"><LockIcon /></span>
              <input
                id="fp-new"
                type="password"
                className={`login-input${error ? ' error' : ''}`}
                placeholder="••••••••"
                value={pwd}
                onChange={(e) => setPwd(e.target.value)}
                autoComplete="new-password"
                disabled={loading}
              />
            </div>
            <p className="login-field-hint">{RULE}</p>
          </div>

          <div className="login-field">
            <label className="login-label" htmlFor="fp-confirm">Repite la contraseña</label>
            <div className="login-input-wrapper">
              <span className="login-input-icon"><LockIcon /></span>
              <input
                id="fp-confirm"
                type="password"
                className={`login-input${error ? ' error' : ''}`}
                placeholder="••••••••"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                autoComplete="new-password"
                disabled={loading}
              />
            </div>
          </div>

          <button type="submit" className="login-submit" disabled={loading}>
            {loading ? (
              <>
                <span className="login-spinner" />
                Guardando…
              </>
            ) : (
              'Guardar contraseña'
            )}
          </button>
        </form>

        <button type="button" className="login-link-btn" onClick={logout} disabled={loading}>
          Cerrar sesión
        </button>
      </div>
    </div>
  );
}
